<template>
  <div ref="scrollPointer" class="mdc-accordion" :class="className">
    <MdcAccordionWrapper
        v-for="(slot, i) in slots"
        :key="i"
        :index="i"
        :label="slot.props.label"
        :sublabel="slot.props.sublabel"
        :newslabel="slot.props.newslabel"
        :image="slot.props.image"
        :icon="slot.props.icon"
        :itemid="slot.props.itemid"
        :opened="opened.indexOf(i) !== -1"
        @toggle="toggle"
    >
      <render-vnode :v-node="slot"></render-vnode>
    </MdcAccordionWrapper>
  </div>
</template>

<script>

import {onMounted, ref, useSlots} from "vue";

import MdcAccordionWrapper from "./MdcAccordionWrapper";

export default {
  name: "mdc-accordion",
  components: {
    MdcAccordionWrapper
  },
  props: {
    single: {
      type: Boolean,
      default: false
    },
    class: {
        type: String,
        default: null
    }
  },
  setup(props) {

    // Get slots for render as content
    const slots = useSlots().default();

    // State of opened mdc-accordion-item´s
    const opened = ref([]);
      const scrollPointer = ref();
    const className = ref(props.class);

    // Toggle state of mdc-accordion-item´s
    const toggle = (index) => {
      let i = opened.value.indexOf(index);
      if (i === -1) {
          props.single?
              opened.value = [index]:
              opened.value.push(index);
      } else {
        opened.value.splice(i,1);
      }
    }

      const findCurrentHash = () => {
          if (
              window.location.hash !== ""
          ) {
              let hash = window.location.hash;
              if (hash.split('-')[0] === "#accItem") {
                  let hashIndex = slots.findIndex((elem) => {
                      return elem.props['itemid']===hash
                  })
                  if (hashIndex !== -1) {
                      scrollPointer.value.scrollIntoView({ behavior: "smooth" });
                      setTimeout(() => {
                          toggle(hashIndex);
                      },1000)
                  }
              }
          }
      }

      onMounted(() => {
          findCurrentHash()
      });

    return {
      slots,
      className,
      opened,
      toggle,
        scrollPointer
    }
  }
}
</script>

<style lang="scss">
@use "@/scss/design-library/_animations.scss";
@use "@/scss/design-library/_typography.scss";
@use "@/scss/design-library/_icons.scss";
@use "@/scss/design-library/_colors.scss";
@use "@/scss/design-library/_grid.scss";

.mdc-accordion {

    &__trigger {
        @extend .animate__image--hover-grow;

        &-button {
            cursor: pointer;
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            column-gap: 26px;
            flex-wrap: wrap;
            border: 0;
            background-color: #{colors.$white};
            box-shadow: none;
            margin: 0;
            padding: 0;
            @include grid.media-query_up_(tablet_portrait) {
                flex-wrap: nowrap;
            }
        }

        &-wrap {
            display: flex;
            flex-direction: row;
            column-gap: 26px;
            align-items: center;
            flex-grow: 1;
        }

        &-image {
            @extend .animate__image--wrap;
            border-radius: 16px 16px 0 0;
            overflow: hidden;
            height: 140px;
            width: 100%;
            display: block;
            flex-shrink: 0;
            margin-bottom: 16px;

            @include grid.media-query_up_(tablet_portrait) {
                border-radius: 16px 0px 0px 16px;
                width: 310px;
                height: 175px;
                margin-bottom: 0;
            }

            @include grid.media-query_(tablet_landscape) {
                width: 442px;
            }

            @include grid.media-query_(desktop) {
                width: 666px;
            }

            img {
                @extend .animate__image--img;
            }

            .newsLabel {
                position: absolute;
                z-index: 100;
                right: 10px;
                top: 10px;
            }
        }

        &-text {
            display: block;
            flex-grow: 1;
        }

        &-label {
            @include typography.headline3();
            display: block;
            color: #{colors.$black};
            text-align: left;
        }

        &-sublabel {
            @include typography.c1();
            display: block;
            color: #{colors.$anthrazit};
            text-align: left;
        }

        &-toggle {
            @extend .material-symbols-outlined;
            font-size: 44px;
            color: #{colors.$anthrazit};
            font-weight: 200;
            display: block;
            flex-shrink: 0;

            @keyframes toogleClose {
                from { rotate: 180deg; }
                to { rotate: 360deg; }
            }

            &.closed {
                animation-name: toogleClose;
                animation-duration: .125s;
                animation-timing-function: linear;
            }

            &.opened {
                transition: rotate linear 125ms;
                rotate: 180deg;
            }
        }
    }

    &__content {
        box-sizing: border-box;
        transition: height ease-in-out 500ms;
        height: 0;
        overflow: hidden;
        background-color: #{colors.$white};

        &.opened {
            height: auto;
        }
    }
}
</style>
